import { StyleSheet } from 'react-native';
import { themes } from 'src/theme/theme';
export const styles = StyleSheet.create({
  modalOverlay: {
    flex: 1,
    justifyContent: 'flex-end', // Align modal at the bottom
    alignItems: 'center',
    backgroundColor: themes.light.modalBackground[1],
    width: '100%',
  },
  modalContainer: {
    width: '100%', // Full width for bottom modal
    backgroundColor: themes.light.white[1],
    borderTopLeftRadius: 20, // Rounded corners at the top
    borderTopRightRadius: 20,
    padding: 16,
    maxHeight: '90%',
  },
  header: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    fontFamily: 'SF Pro Display',
    fontWeight: 'bold',
    fontSize: 20,
    color: themes.light.gray_blue[1],
  },
  closeIcon: {
    width: 24, // Set image width to 24px
    height: 24, // Set image height to 24px
    alignItems: 'center',
    justifyContent: 'center',
  },
  closeImage: {
    width: 20, // Set image width to 24px
    height: 20, // Set image height to 24px
    resizeMode: 'contain', // Ensure the image scales well
  },
  radioButtons: {
    paddingTop: 8,
    gap: 20,
    width: '100%',
  },
  radioButtonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between', // Align text and button at opposite ends
    alignItems: 'center',
    marginBottom: 10,
  },
  radioButtonLabel: {
    fontSize: 16,
    textAlign: 'left', // Ensure text aligns to the left
    flex: 1, // Allow label to take available space
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between', // Space between buttons
    gap: 8,
    width: '100%',
    paddingVertical: 12,
  },
  buttonWrapper1: {
    flex: 1, // Allow it to grow
    maxWidth: '33%', // Restrict to 33% width
  },
  buttonWrapper2: {
    flex: 1, // Allow it to grow
    maxWidth: '67%', // Restrict to 67% width
  },
});
